
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import iteratorsCore from './iterators-core.js';
import objectCreate from './object-create.js';
import createPropertyDescriptor$1 from './create-property-descriptor.js';
import setToStringTag$1 from './set-to-string-tag.js';
import iterators from './iterators.js';

var IteratorPrototype = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$1;
var setToStringTag = setToStringTag$1;
var Iterators = iterators;

var returnThis = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

export { iteratorCreateConstructor as default };
//# sourceMappingURL=iterator-create-constructor.js.map
